import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { TwilioCheckRequestBody, TwilioCheckResponse } from "./types";

export class TwilioCheckAPI extends BaseAPI<
  TwilioCheckRequestBody,
  TwilioCheckResponse
> {
  protected route = ApiRoutes.twilio.check;
  protected method = RequestMethod.POST;
}
